import { StaffTable } from "./components/StaffTable";
import { useNavigate } from "react-router";
import { PersonDataType, useSelectedPerson } from "../../context/SelectedPersonContext";
import { useExpirePerson } from "../Manage/hooks/useExpirePerson";
import { useManageModal } from "ui";
import usePersonStore from "../store/personStore";
import usePersonAuthStore, { UserRoleHierarchy } from "../store/personAuthStore"
import { canAddStudentAndStaff } from "ft-shared-graphql";
type ViewAllStaffProps = {
    onBack: () => void
}

export const ViewAllStaff = ({ onBack }: ViewAllStaffProps) => {
    const navigate = useNavigate();
    const { openModal, closeModal } = useManageModal();
    const { setSelectedPerson } = useSelectedPerson();
    const { expirePerson } = useExpirePerson();
    const roles = usePersonAuthStore(state => state.roles)
    const handleSelectedPersonDetails = (person: PersonDataType) => {
        setSelectedPerson(person)
        navigate(`/manage/users/details/${person?.id}`)
    }
    const myId = usePersonStore(state => state.id);
    const myHighestRole = usePersonAuthStore((state) => state.highestRole)
    const handleExpirePerson = (person: PersonDataType) => {

        if (person?.id == myId) {
            openModal({ type: "CANNOT_ARCHIVE_SELF" })
        }
        // else if (UserRoleHierarchy[myHighestRole!.replace(" ", "_") as keyof typeof UserRoleHierarchy] < UserRoleHierarchy[person?.role?.normalizedName.replace(" ", "_") as keyof typeof UserRoleHierarchy]
        // ) {
        //     openModal({ type: "CANNOT_ARCHIVE_HIGHER_USER" })
        // }
        else if (!person?.expired) {
            openModal({
                type: "EXPIRE_PERSON",
                confirmButtonType: "WARNING",
                confirmButtonLabel: "Expire",
                onConfirm: async () => {
                    openModal(state => ({ ...state, status: "SAVING" }))
                    await expirePerson(person?.id);
                    closeModal()
                }
            })
        } else {
            console.log("???")
            openModal({ type: "REACTIVATE" })
        }
    }
    return (
        <StaffTable
            title="Manage Users"
            showNew={canAddStudentAndStaff(roles)}
            onBack={onBack}
            onSelectedPerson={(person, action) => {
                switch (action) {
                    case "DETAILS":
                        handleSelectedPersonDetails(person)
                        break;
                    case "EXPIRE":
                        handleExpirePerson(person)
                        break;
                    default:
                        throw Error(`Although the student ${person.id} is selected, action ${action} is not implemented`);
                }
            }}
        />
    )
}